import { Customer } from "shared";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "../not-found";
import { AccountProfile } from "../ui/AccountProfile";
import { PolicyDetailsWithSuspense } from "../ui/PolicyDetails";
import { SettingsWithSuspense } from "../ui/Settings";
import {
  DocumentDeliveryPageWithSuspense,
  EditMailingAddressPageWithSuspense,
  EditNamePageWithSuspense,
  EditPhoneNumberPageWithSuspense,
} from "../ui/SettingsPage";

type AppRouteTypes = {
  customer: Customer;
};

export const AppRoutes = ({ customer }: AppRouteTypes) => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<AccountProfile customer={customer} />} />
      <Route
        path="/settings/name"
        element={<EditNamePageWithSuspense initialCustomer={customer} />}
      />
      <Route
        path="/settings/address"
        element={
          <EditMailingAddressPageWithSuspense initialCustomer={customer} />
        }
      />
      <Route
        path="/settings/phone"
        element={<EditPhoneNumberPageWithSuspense initialCustomer={customer} />}
      />
      <Route
        path="/settings/document-delivery"
        element={<DocumentDeliveryPageWithSuspense />}
      />
      <Route
        path="/settings"
        element={<SettingsWithSuspense initialCustomer={customer} />}
      />
      <Route
        path="/policy/:policyNumber"
        element={<PolicyDetailsWithSuspense />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);
